<template>
  <v-flex
    pb-3
    xs12
    md8
    class="extract-offer-detail"
  >
    <v-layout mb-3 pa-2 class="alert">
      <v-flex px-3>
        <v-img
          class="bg-white"
          width="25"
          height="25"
          :src="suggestionIcon"
        />
      </v-flex>
      <v-flex>
        <span>{{ $t('message.bizgainOnboarding.offerAlert') }}</span>
      </v-flex>
    </v-layout>
    <image-card-row
      class="image-cardv2"
      :col-width="'xs6 md6'"
      :card-height="cardHeight"
      :objects="offerCardType"
      :select-card-id="offerCardTypeSelected"
      :class="{'mt-2': !$vuetify.breakpoint.xsOnly}"
      :shrink="true"
      :img-width="$vuetify.breakpoint.xsOnly ? '40' : '45'"
      :img-height="$vuetify.breakpoint.xsOnly ? '40' : '45'"
      @selected-card="setOfferCardTypeSelected"
    >
      <template v-slot:title="objectiveTitle">
        {{ $t(objectiveTitle.title) }}
      </template>
    </image-card-row>
    <v-card>
      <div v-if="isWithOffer">
        <v-flex
          px-3
          xs12
          :class="{ 'px-0 pt-2': $vuetify.breakpoint.xsOnly }"
        >
          <div class="label">
            {{ $t('message.bizgainOnboarding.offerType') }}
          </div>
          <v-layout>
            <v-select
              :items="offerTypes"
              v-model="selectedOfferType"
              class="py-0 my-0"
              :disabled="isUpdateOfferDetails"
            />
          </v-layout>
          <div class="v-messages offer-type-hint theme--light">
            {{ offerTypePlaceholderLeft }} <span style="color:black;">{{ offerTypePlaceholder }}</span> {{ offerTypePlaceholderRight }}
          </div>
        </v-flex>
        <v-flex xs12 d-flex>
          <v-flex
            xs6
            md6
            pb-3
            ml-3
            v-if="isPercentageOffer"
          >
            <div class="label">
              {{ $t('message.bizgainOnboarding.percentage') }}
            </div>
            <custom-text-field
              :placeholder="'Ex: 20'"
              :type="'number'"
              :name="'percentage'"
              v-model="percentage"
              :classes="'pt-0 mt-0'"
              :autocapitalize="'off'"
              :validation="`${ isPercentageOffer ? 'required|numeric|min:1|max:2|excluded:0,00' : '' }`"
              :error-messages="$t('message.bizgainOnboarding.percentageValidationMessages')"
              :disabled="isUpdateOfferDetails?true:false"
              :counter="'2'"
              :icon="'mdi-check'"
              @input="setOfferDetails"
            />
          </v-flex>
          <v-flex
            xs6
            md6
            px-3
            v-if="isflatOffer"
            :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
          >
            <div class="label">
              {{ $t('message.bizgainOnboarding.flat') }}
            </div>
            <custom-text-field
              :placeholder="'Ex: 200'"
              :type="'number'"
              :name="'flat'"
              v-model="flat"
              :classes="'pt-0 mt-0'"
              :autocapitalize="'off'"
              :validation="`${ isflatOffer ? 'required|min:1|max:5|decimal' : '' }`"
              :counter="'5'"
              :error-messages="$t('message.bizgainOnboarding.currencyRequiredValidationMessage')"
              :disabled="isUpdateOfferDetails?true:false"
              :icon="'mdi-check'"
              @input="setOfferDetails"
            />
          </v-flex>
          <v-flex
            px-3
            pb-3
            :class="[{ 'px-0': $vuetify.breakpoint.xsOnly, 'x12': isCustomOffer && isFreeService, 'xs6': !isCustomOffer && !isFreeService}]"
          >
            <div class="label">
              {{ isCustomOffer?$t('message.bizgainOnboarding.offer'):$t('message.bizgainOnboarding.service') }}
            </div>
            <custom-text-field
              :placeholder="servicePlaceHolders"
              :classes="'pt-0 mt-0'"
              :name="'service'"
              v-model="service"
              :autocapitalize="'off'"
              :counter="serviceLength"
              :validation="'required|max:'+ serviceLength"
              :error-messages="$t('message.bizgainOnboarding.serviceRequiredValidationMessage', { n: serviceLength })"
              :disabled="isUpdateOfferDetails"
              :icon="'mdi-check'"
              @input="setOfferDetails"
            />
          </v-flex>
        </v-flex>
      </div>
      <div v-else>
        <v-flex pb-3 px-3>
          <div class="label">
            {{ $t('message.bizgainOnboarding.promotionLine') }}
          </div>
          <custom-text-field
            v-model="promotionText"
            :type="'text'"
            :classes="'pt-0'"
            :name="'promotionText'"
            :placeholder="promotionTextPlaceholder"
            :autocapitalize="'off'"
            :counter="promoTextLength"
            :error-messages="$t('message.bizgainOnboarding.promotionTextValidationMessage')"
            :validation="'required|max:'+ promoTextLength"
            :icon="'mdi-check'"
            @input="setOfferDetails"
          />
        </v-flex>
      </div>
    </v-card>
  </v-flex>
</template>
<script>
import {
  VLayout,
  VFlex,
  VSelect,
  VCard,
  VImg
} from 'vuetify/lib';
import clearErrorByField from 'Mixins/clearErrorByField';
import { bizgainOnboardingImage, offerTypes, offerType, bizgainOnboardingRoutes, callToActions, offerCardType, privacyPolicyDataAccessTypes } from 'Features/bizgainOnboarding/constants';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import ImageCardRow from 'Components/ImageCardRow/ImageCardRow.vue';
import onboardingRedirect  from 'Mixins/onboardingRedirect';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import { Validator } from 'vee-validate';

export default {
  mixins: [clearErrorByField, onboardingRedirect],
  props: ['promotionCopy', 'businessType'],
  components: {
    VLayout,
    VFlex,
    VSelect,
    VCard,
    ImageCardRow,
    VImg,
    CustomTextField
  },
  data() {
    return {
      bizgainOnboardingImage: bizgainOnboardingImage,
      offerTypes: offerTypes,
      offerType: offerType,
      selectedOfferType: offerType.percentageOffer,
      validTillDateInput: null,
      validTillDateMenu: false,
      service: null,
      percentage: null,
      flat: null,
      isExpireable: true,
      servicePlaceHolder: null,
      bizgainOnboardingRoutes,
      isUpdateOfferDetails: false,
      callToActions,
      promoTextLength: '30',
      promotionText: null,
      businessTypeText: null,
      offerCardType,
      offerCardTypeSelected: offerCardType.withOffer.id,
      privacyPolicyDataAccessTypes,
      previouslySelectedOfferType: offerType.percentageOffer,
      isValidOfferDetails: false,
      suggestionIcon: bizgainOnboardingImage.suggestionIcon
    }
  },
  created() {
    Validator.localize('en');
    if (this.offerDetail) {
      if (this.offerDetail.type != this.offerType.skip) {
        this.offerCardTypeSelected = this.offerCardType.withOffer.id;
        this.selectedOfferType = this.offerDetail.type;
        this.service = this.offerDetail.service;
        this.isExpireable = this.offerDetail.isExpireable;
        if(this.offerDetail.validTill){
          this.validTillDateInput = moment(this.offerDetail.validTill).format('YYYY-MM-DD');
        }
        this.percentage = this.offerDetail.percentage ? this.offerDetail.percentage : null;
        this.flat = this.offerDetail.amount ? this.offerDetail.amount : null;
      }
      else{
        this.offerCardTypeSelected = this.offerCardType.withoutOffer.id;
        this.autoFillService();
      }
      this.$emit('offerDetails', this.offerDetails, true);
    }
    else{
      if(this.promoteServices){
        this.autoFillService();
      }
    }
    this.promotionText = this.generatePromotionText();
    this.setBusinessTypeText();
  },
  computed: {
    ...mapGetters(['businessDetails', 'offerDetail', 'promoteServices', 'isError', 'businessProfileId', 'roimaticCampaignId', 'objective', 'portal', 'regionCurrencySymbol']),
    disableNext(){
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
          if(!this.isExpireable)
            return !this.percentage || !this.service || !this.validTillDateInput;
          return !this.percentage || !this.service;
        case this.offerType.flatOffer:
          if(!this.isExpireable)
            return !this.flat || !this.service || !this.validTillDateInput;
          return !this.flat || !this.service;
        case this.offerType.freeService:
        case this.offerType.custom:
          if(!this.isExpireable)
            return !this.service || !this.validTillDateInput;
          return !this.service;
        case this.offerType.skip:
          return !this.promotionText;
        default:
          return true;
      }
    },
    serviceLength: function () {
      let serviceLength;
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer: serviceLength = '19';break;
        case this.offerType.flatOffer: serviceLength = '16';break;
        case this.offerType.freeService: serviceLength = '25';break;
        case this.offerType.custom: serviceLength = '30';break;
      }
      return serviceLength;
    },
    displayDate(){
      return this.validTillDateInput ? moment(this.validTillDateInput).format('DD MMM YYYY') : ''
    },
    datePlaceholder() {
      return `${moment().add(30, 'days')
        .format('DD MMM YYYY')}`
    },
    isPercentageOffer() {
      return this.selectedOfferType === this.offerType.percentageOffer;
    },
    isflatOffer() {
      return this.selectedOfferType === this.offerType.flatOffer;
    },
    isCustomOffer(){
      return this.selectedOfferType == this.offerType.custom;
    },
    isFreeService() {
      return this.selectedOfferType === this.offerType.freeService;
    },
    isWithOffer(){
      return this.offerCardTypeSelected ==  this.offerCardType.withOffer.id;
    },
    cardHeight(){
      if(this.$vuetify.breakpoint.xsOnly){
        return this.$vuetify.breakpoint.width <= 317 ? 90 : 80;
      }
      return 90;
    },
    offerTypePlaceholderLeft(){
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
          return this.percentage ? '' : '20%';
        case this.offerType.flatOffer:
          return this.flat ? '' : this.regionCurrencySymbol + '200';
        case this.offerType.freeService:
          return '';
        case this.offerType.custom:
          return this.service ? '' : 'Custom Offer';
        default:
          return '';
      }
    },
    offerTypePlaceholderRight(){
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
        case this.offerType.flatOffer:
          return this.service ? '' : (this.businessTypeText || 'Haircut');
        case this.offerType.freeService:
        case this.offerType.custom:
        default:
          return '';
      }
    },
    offerTypePlaceholder(){
      let placeHolder;
      switch(this.selectedOfferType){
        case this.offerType.percentageOffer:
          placeHolder = ' Off on ';
          if (this.percentage) placeHolder = this.percentage + '%' + placeHolder;
          if (this.service) placeHolder += this.service;
          return placeHolder;
        case this.offerType.flatOffer:
          placeHolder = ' Off on ';
          if (this.flat) placeHolder = this.regionCurrencySymbol + this.flat + placeHolder;
          if (this.service) placeHolder += this.service;
          return placeHolder;
        case this.offerType.freeService:
          placeHolder = 'Free ';
          return this.service ? placeHolder + this.service : placeHolder;
        case this.offerType.custom:
          return this.service ? this.service : '';
        default:
          return '';
      }
    },
    servicePlaceHolders(){
      if(this.selectedOfferType == this.offerType.custom){
        return 'Ex: Custom offer';
      }
      else if(this.servicePlaceHolder){
        return 'Ex: ' + this.servicePlaceHolder;
      }
      return 'Ex: Haircut';
    },
    promotionTextPlaceholder(){
      return this.promotionCopy ? 'Ex: ' + this.promotionCopy : this.$t('message.bizgainOnboarding.promotionLineHint');
    }
  },
  watch: {
    offerCardTypeSelected(value){
      this.clearErrorByField(null, 'percentage');
      this.clearErrorByField(null, 'flat');
      this.clearErrorByField(null, 'service');
      this.clearErrorByField(null, 'promotionText');
      this.$emit('offerDetails', {}, false);
      if (value == this.offerCardType.withoutOffer.id){
        this.previouslySelectedOfferType = this.selectedOfferType;
        this.selectedOfferType = this.offerType.skip;
        this.setOfferDetails()
      }
      else{
        if (this.previouslySelectedOfferType){
          this.selectedOfferType = this.previouslySelectedOfferType;
          this.setOfferDetails()
        }
        else{
          this.selectedOfferType = this.offerType.percentageOffer;
          this.setOfferDetails()
        }
      }
    },
    promotionCopy(value){
      this.promotionText = value;
      this.setOfferDetails();
    },
    businessType(){
      this.setBusinessTypeText();
    },
    selectedOfferType(value){
      this.setOfferDetails()
    }

  },
  methods: {
    ...mapActions(['setCurrentSection', 'setCurrentRoute', 'updateOfferDetails', 'clearCreativeImages', 'clearMessages']),
    disablePastDates(val) {
      return val >= new Date().toISOString()
        .substr(0, 10)
    },
    async setOfferDetails(){
      this.isValidOfferDetails = false;
      this.isUpdateOfferDetails = true
      let offerDetails;
      if (this.isWithOffer){
        offerDetails = {
          type: this.selectedOfferType,
          service: this.service,
          isExpireable: this.isExpireable,
          validTill: this.validTillDateInput
        }
        if (this.selectedOfferType === this.offerType.percentageOffer){
          offerDetails.percentage = this.percentage;
          if(offerDetails.percentage && offerDetails.service){
            this.isValidOfferDetails = true;
            this.$emit('offerDetails', offerDetails, this.isValidOfferDetails);
          }
        }
        else if (this.selectedOfferType === this.offerType.flatOffer){
          offerDetails.amount = this.flat;
          if(offerDetails.amount && offerDetails.service){
            this.isValidOfferDetails = true;
            this.$emit('offerDetails', offerDetails, this.isValidOfferDetails)
          }
        }
        else if(offerDetails.service){
          this.isValidOfferDetails = true;
          this.$emit('offerDetails', offerDetails, this.isValidOfferDetails)
        }
      }
      else{
        offerDetails = {
          type: this.offerType.skip,
          customOffer: this.promotionText
        }
        if(offerDetails.customOffer){
          this.isValidOfferDetails = true;
          this.$emit('offerDetails', offerDetails, this.isValidOfferDetails)
        }
      }
      this.isValidOfferDetails = false;
      this.isUpdateOfferDetails = false;
    },
    autoFillService(){
      this.service = null;
      this.servicePlaceHolder = 'Haircut';
      if (this.promoteServices && this.promoteServices.length > 0){
        let serviceName =  this.promoteServices.reduce((a, b) => a.length <= b.length ? a : b);
        if(serviceName.length <= this.serviceLength)
        {
          this.service = serviceName
        }
      }
    },
    generatePromotionText(){
      if (this.offerDetail && this.offerDetail.type == this.offerType.skip && this.offerDetail.customOffer) {
        return this.offerDetail.customOffer;
      }else if(this.businessDetails && this.businessDetails.category.presetData.promotionCopy){
        return this.businessDetails.category.presetData.promotionCopy
      }else if(this.businessDetails && this.businessDetails.category.displayName){
        return `Best ${this.businessDetails.category.displayName}`
      }
    },
    setOfferCardTypeSelected(value){
      this.offerCardTypeSelected = value;
    },
    setBusinessTypeText(){
      var displayText = this.businessType && this.businessType.value && this.businessType.value.displayName;
      this.businessTypeText = displayText;
      this.servicePlaceHolder = displayText;
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 8px !important;
}
.skip-btn-color.v-btn {
  color: var(--v-primary-base);
  height: 40px !important;
  font-weight: 600 !important;
}
::v-deep.skip-offer {
  text-decoration: underline;
  columns: var(--v-primary-base);
  font-size: 15px;
  line-height: 1.33;
}
::v-deep.extract-offer-detail {
  .label {
    padding-top: 16px !important;
    padding-bottom: 0 !important;
  }
  .v-input--checkbox {
    .v-label {
      line-height: 1.33;
      font-weight: normal;
      font-size: 14px !important;
      letter-spacing: normal;
      color: var(--v-black-base);
    }
  }
  .v-input--radio-group {
    .v-label {
      color: var(--v-black-base);
    }
  }
}
.extend-prefix-width{
    width: 110px !important;
}
.prefix{
  line-height: 24px;
}
.alert{
  border: 1px solid var(--v-primary-base);
  border-radius: 5px;
  background: #F2FFFF;
  align-items: center;
}

::v-deep .v-messages{
  min-height: 0px !important;
}

::v-deep .offer-type-hint{
  margin-top: -5px !important;
}

  ::v-deep .image-cardv2 .card-content{
    padding: 0px !important;
  }
  ::v-deep .image-cardv2 .card-content .v-sheet{
    border-radius: 0px !important;
  }
  ::v-deep .image-cardv2 .card-content .v-card.v-sheet.theme--light.selected-card{
    border-top: 0px !important;
    border-right: 0px !important;
    border-left: 0px !important;
    border-bottom: 5px solid var(--v-primary-base);
  }
  ::v-deep .image-text-card .flex .v-card:hover{
    border:0px
  }

</style>